module.exports = __webpack_public_path__ + "img/newdental-logo.a4f2a464.svg";